import RedirectActionTypes from '../actionTypes/RedirectActionTypes';

const setRedirectUrl = (redirectData) => ({
    type: RedirectActionTypes.SET_REDIRECT_URL,
    redirectData,
});

export default {
    setRedirectUrl,
};
